module.exports = __webpack_public_path__ + "static/media/receiptPage _1.f83fbb79.png";